import axios from "axios";

export async function fetchSpinInfo(spinURL) {
  const infoUrl = `${spinURL}?info`;
  const response = await axios.get(infoUrl, {
    headers: {
      "Cache-Control": "no-cache",
    },
  });
  const json = response.data;
  return json;
}
